module.exports = __webpack_public_path__ + "img/big_1_70.aa50187e.png";